import { Pipe, PipeTransform } from '@angular/core';

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { BusinessOwner } from '../business-owner/business-owner.dto';
import { BusinessOwnerService } from '../business-owner/business-owner.service';

@Pipe({ name: 'asyncBusinessOwnerAll' })
export class AsyncBusinessOwnerPipeAll implements PipeTransform {
    constructor(private businessOwnerService: BusinessOwnerService) {}

    transform(input: any) {
        return this.businessOwnerService
            .getAll()
            .pipe(
                map(value =>
                    value.sort((n1, n2) => (n1.fullname < n2.fullname ? -1 : 1))
                )
            );
    }
}
